<template>
  <div>
    <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
        <router-link :to="{ path: '/main'}">
          <button type="submit" class="btn btn-danger btn-sm px-2 mr-2">Anasayfa Slider</button>
        </router-link>
        <router-link :to="{ path: '/intro-video'}">
          <button type="submit" class="btn btn-primary active btn-sm mr-2 px-2">İntro Videosu</button>
        </router-link>
        <router-link :to="{ path: '/homeboxes'}">
          <button type="submit" class="btn btn-info btn-sm mr-2 px-2">Anasayfa Kutular</button>
        </router-link>
        <router-link :to="{ path: '/homeinfos'}">
          <button type="submit" class="btn btn-warning btn-sm mr-2 px-2">Anasayfa Bilgiler</button>
        </router-link>
        <router-link :to="{ path: '/announcements'}">
          <button type="submit" class="btn btn-success btn-sm mr-2 px-2">Anasayfa Duyurular</button>
        </router-link>
      </div>
      <span></span>
    </div>
    <card>
      <form class="w-100" @submit="submit">
        <div class="row">
          <div v-if="!err" class="col-md-12">
            <div class="d-flex flex-column">
              <label :for="settings.name">
                <span class="title">{{settings.meta.title}}</span>
              </label>
              <div class="video d-flex justify-content-around align-items-center">
                <div ref="video"></div>
                <div class="d-flex justify-content-around w-100 align-items-center">
                  <label class="ml-4 btn btn-lg btn-danger mb-0" for="intro">Dosya Seç</label>
                  <input
                    type="file"
                    id="intro"
                    v-on:change="uploadVideo($event)"
                    style="display:none"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="err">
            {{err}}
          </div>
        </div>
      </form>
    </card>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";
export default {
  data: function() {
    return {
      settings: {
        name: null,
        meta: {
          title: null
        },
        data: null
      },
      err:null,
      file: null,
      imageIndex: -1,
      image: {
        cropped: null
      },
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      }
    };
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    generatePreview: function() {
      if (this.$refs.video) {
        this.$refs.video.innerHTML = '';
        let video = document.createElement('video');
        let source = document.createElement('source');
        source.type = 'video/mp4';
        source.src = this.generalURL('introvideo') + this.settings.data;
        video.appendChild(source);
        video.controls = true;
        video.loop = true;
        video.load();
        video.play();
        this.$refs.video.appendChild(video);
      }
    },
    getSettings: function() {
      this.toggleLoader();
      this.$http.get("/api/settings/get-intro-video/").then(
        response => {
          this.settings = response.body;
           this.settings.meta = JSON.parse(this.settings.meta);
          this.generatePreview();
          // for (var i = 0; i < this.settings.length; i++) {
          //   this.settings[i].meta = JSON.parse(this.settings[i].meta);
          // }

          this.toggleLoader();
        },
        er => {

            if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
            this.toggleLoader();
        }
      );
    },
    uploadVideo: function(event) {
      this.file = event.target.files[0];
      if (
        !(
          this.file.type === "video/mpeg" ||
          this.file.type === "video/webm" ||
          this.file.type === "video/mp4" ||
          this.file.type === "video/quicktime"
        )
      ) {
        this.notifier(
          "top",
          "right",
          "danger",
          "Lütfen mp4 formatında bir dosya seçiniz"
        );
      } else {
        let data = new FormData();
        data.append("file", this.file);
        let fileName = this.file.name.split(".");
        let extension = "";
        let newName = "";
        fileName.forEach((e, index) => {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName = this.slugify(newName);
        newName += new Date().getTime();
        let fullName = newName + "." + extension;
        this.settings.data = fullName;
        data.append("fileName", fullName);
        this.notifier(
          "top",
          "right",
          "warning",
          "Dosya yüklenirken lütfen bekleyiniz.Yüklemeden sonra sayfa yenilenecektir"
        );
        this.$http.post("api/files/upload-intro-video/" + fullName, data).then(
          response => {
            this.notifier(
              "top",
              "right",
              "success",
              "Video başarıyla kaydedildi"
            );
            this.submit();
            // this.$router.go();
          },
          er => {
            if(!er.body.Error){
            this.notifier(
              "top",
              "right",
              "danger",
              "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
            );
            }else{
            this.notifier(
              "top",
              "right",
              "danger",
              er.body.Error
            );
            }

          }
        );
      }
    },
    submit: function() {
      event.preventDefault();
      this.$http.post("/api/settings/update-one/", this.settings).then(
        response => {
          this.notifier("top", "right", "success", "Başarıyla güncellendi");
          this.getSettings();
        },
        e => {
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        }
      );
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getSettings();
    });
  }
};
</script>
<style>
.video iframe {
  width: 600px;
  height: 600px;
}
.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: #007bff !important;
}
.nav-pills:focus {
  outline: none;
}
.nav-pills a {
  color: #000;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  color: #fff;
}
.nav-item {
  margin-bottom: 5px;
}
.menu-item:hover {
  cursor: move;
}
.panel-map {
  width: 100%;
  height: 2.7rem !important;
  margin-bottom: 1rem;
}
label .title {
  text-transform: capitalize;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/IntroVideoModules/Index.vue